export default __webpack_public_path__ + "static/media/mc.46f06124.jpg";